module.exports = __webpack_public_path__ + "static/media/monitores-apagados.7201e42e.jpg";